export const SENTRY_BLACKLIST_URLS = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];

// Ignore list based off: https://gist.github.com/1878283
export const SENTRY_IGNORE_ERRORS = [
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  /**
   * Our own
   */
  "Cannot read property '_avast_submit' of undefined",
  'SecurityError: Permission denied to access property "document" on cross-origin object',
  `SecurityError: Blocked a frame with origin "${
    (typeof window !== "undefined" && window.location.origin) ||
    "smmplanner.com"
  }" from accessing a cross-origin frame.`,
  "Non-Error promise rejection captured with value: Timeout",
  "reCAPTCHA Timeout",
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node",
  /**
   * CarrotQuest
   */
  "Cannot read property 'currentConversation' of undefined",
  /**
   * Api
   */
  "API__INTERNAL__401_UNAUTHORIZED",
  "API__INTERNAL__403_FORBIDDEN",
  "API__INTERNAL__404_NOT_FOUND",
  "API__INTERNAL__500_INTERNAL_SERVER_ERROR",
];
